"use client";

import { c as _c } from "react/compiler-runtime";
import CommonDropdown from "@/components/utils/select/dropdown/CommonDropdown";
import { ContractFilter, TypeFilter } from "@/hooks/useActivityData";
import { Col } from "react-bootstrap";
interface ActivityFiltersProps {
  readonly typeFilter: TypeFilter;
  readonly selectedContract: ContractFilter;
  readonly onTypeFilterChange: (filter: TypeFilter) => void;
  readonly onContractFilterChange: (contract: ContractFilter) => void;
  readonly isMobile: boolean;
}
const ActivityContractItems = Object.freeze(Object.values(ContractFilter).map(contract => ({
  key: contract,
  label: contract,
  value: contract
})));
export const ActivityTypeItems = Object.freeze(Object.values(TypeFilter).map(type => ({
  key: type,
  label: type,
  value: type
})));
export default function ActivityFilters(t0) {
  const $ = _c(10);
  const {
    typeFilter,
    selectedContract,
    onTypeFilterChange,
    onContractFilterChange,
    isMobile
  } = t0;
  const t1 = `tailwind-scope d-flex align-items-center gap-4 tw-py-2 ${isMobile ? "justify-content-center" : "justify-content-end"}`;
  let t2;
  if ($[0] !== onContractFilterChange || $[1] !== selectedContract) {
    t2 = <CommonDropdown items={ActivityContractItems} activeItem={selectedContract} filterLabel="Collection" setSelected={onContractFilterChange} />;
    $[0] = onContractFilterChange;
    $[1] = selectedContract;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onTypeFilterChange || $[4] !== typeFilter) {
    t3 = <CommonDropdown items={ActivityTypeItems} activeItem={typeFilter} filterLabel="Transaction Type" setSelected={onTypeFilterChange} />;
    $[3] = onTypeFilterChange;
    $[4] = typeFilter;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <Col sm={12} md={6} className={t1}>{t2}{t3}</Col>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}